exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-dialog{border-radius:8px !important}@media screen and (min-width: 800px){.roleTable{width:70%}}\n", ""]);

// exports
